<template>
  <div class="m-style">
    <div class="location">
      当前位置：
      <router-link :to="{ path: '/' }" class="a">首页</router-link
      >&nbsp;&gt;&nbsp;
      <router-link
        :to="{ path: '/weekReport', query: { uid: currentReportUid } }"
        class="a"
        >{{ currentReportUid }}</router-link
      >&nbsp;&gt;&nbsp;
      <a class="a" href="javascript:;">{{ currentFieldname }}</a>
    </div>
    <ul class="qb_main_ul">
      <li v-for="item in docsData" :key="item.code" class="clearfix">
        <a
          :href="
            indexLinkURL +
            '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
            item.chnid +
            '&leafid=' +
            item.leafid +
            '&docid=' +
            item.code.substring(4, item.code.length) +
            '&uid=' +
            item.uid +
            '&version=dReport'
          "
          target="_blank"
          class="fl m-title"
          :title="item.title"
        >
          <span class="d_icon">·</span>
          <span :title="item.title">{{ item.title }}</span>
        </a>
        <span class="fr time">{{ item.deliveddate }}</span>
      </li>
    </ul>

    <div class="y-pagination" v-if="windowWidth > 769">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :current-page="currentPage"
        layout="prev, pager, next, jumper, total"
        :total="total"
      ></el-pagination>
    </div>
    <div class="y-pagination" v-if="windowWidth < 769" style="margin:16px auto;width:251px">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :current-page="currentPage"
        layout="prev, pager, next"
        small
        :pager-count="5"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { api } from "@/pages/index/require/api.js";
export default {
  data() {
    return {
      docsData: [],
      currentReportUid: "",
      currentId: "",
      currentFieldname: "",
      total: 0,
      currentPage: 1,
      pageSize: 29,
      indexLinkURL: window.indexLinkURL,
    };
  },
  created() {
    this.currentReportUid = this.$route.query.uid;
    this.$route.query.id === undefined
      ? (this.currentId = "90")
      : (this.currentId = this.$route.query.id);
    this.currentFieldname = this.$route.query.idname;
    this.currentPage = 1;
    if (this.currentReportUid === "全部报告") {
      this.pageSize = 53;
      this.loadAllReportsDocs();
    } else {
      this.pageSize = 29;
      this.loadDocs();
    }
  },
  watch: {
    $route() {
      this.currentReportUid = this.$route.query.uid;
      this.$route.query.id === undefined
        ? (this.currentId = "90")
        : (this.currentId = this.$route.query.id);
      this.currentFieldname = this.$route.query.idname;
      this.currentPage = 1;
      if (this.currentReportUid === "全部报告") {
        this.pageSize = 53;
        this.loadAllReportsDocs();
      } else {
        this.pageSize = 29;
        this.loadDocs();
      }
    },
  },
  methods: {
    async loadDocs() {
      const { code, data } = await api.get("/indexController/getIndexDocs", {
        uid: this.currentId,
        reportType: this.currentReportUid,
        currpage: this.currentPage,
        pagesize: this.pageSize,
        isIndexSearch: false,
        time: new Date().getTime(),
      });
      this.docsData = [];
      this.total = 0;
      if (code === 0) {
        if (this.currentReportUid === "周评") {
          this.docsData = data.weekreport.data;
          this.total = data.weekreport.totlalCount;
        } else if (this.currentReportUid === "月度报告") {
          this.docsData = data.monthreport.data;
          this.total = data.monthreport.totlalCount;
        } else if (this.currentReportUid === "季度报告") {
          this.docsData = data.quarterreport.data;
          this.total = data.quarterreport.totlalCount;
        } else if (this.currentReportUid === "热点报告") {
          this.docsData = data.hotreport.data;
          this.total = data.hotreport.totlalCount;
        }
      }
    },
    async loadAllReportsDocs() {
      const { code, data } = await api.get("/indexController/getAllReports", {
        curpage: this.currentPage,
        pagesize: this.pageSize,
        time: new Date().getTime(),
      });
      this.docsData = [];
      this.total = 0;
      if (code === 0) {
        this.docsData = data.data;
        this.total = data.totlalCount;
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.currentReportUid === "全部报告") {
        this.pageSize = 53;
        this.loadAllReportsDocs();
      } else {
        this.pageSize = 29;
        this.loadDocs();
      }
    },
  },
};
</script>

<style lang='less' scoped>
.qb_main_ul {
  margin-left: 11px;
  margin-top: 15px;
  li {
    line-height: 30px;
    a {
      font-size: 15px;
      color: #333;
      display: block;
      width: 80%;
      overflow: hidden;
      -o-text-overflow: ellipsis;
      text-overflow: ellipsis;
      white-space: nowrap;
      .d_icon {
        font-size: 14px;
        font-weight: bold;
        color: #caccce;
        padding-right: 5px;
      }
    }
    .time {
      color: #666;
    }
  }
  li:nth-child(6n) {
    margin-top: 25px;
  }
  li:hover a,
  li:hover .time {
    color: #0770b9;
  }
}
.y-pagination {
  font-family: "microsoft yahei";
  font-size: 12px;
  margin: 30px 0;
  padding-bottom: 20px;
}
/deep/.el-pagination__jump {
  margin: 0 24px;
}
@media screen and (max-width: 769px) {
  .m-style{
    width: 100%;
    padding: 0 16px 0 4px;
  }
  .m-title{
    display: inline-block !important;
    width: calc(100% - 74px - 15px) !important;
  }
}
</style>